<script>
  import SupplierContactComponent from './SupplierContactComponent.svelte';

  export let representatives, edit, select;

  const
    GROUPED_VIEW_CONTACTS_COUNT = 4,
    STALE_CONTACT_YEARS = 3,
    sections = {
      active: {
        id: 'active',
        label: 'Registered Users',
        description: 'Active registered users with deliverable email address. Recommended.',
        open: true
      },
      stale: {id: 'stale', label: 'Inactive Users', description: 'Registered users not active for more than 3 years.'},
      contacts: {id: 'contacts', label: 'Contacts', description: 'Non-user contacts', open: true},
      badEmails: {id: 'badEmails', label: 'Bad Emails', description: 'Email addresses that have bounced or complained'}
    },
    repsLength = representatives.length,
    staleDateThreshold = getStaleDateThreshold();

  let groupedRepresentatives;

  $: groupedRepresentatives = checkOpenClosed(repsLength >= GROUPED_VIEW_CONTACTS_COUNT? groupRepresentatives(representatives): null);

  function groupRepresentatives(reps) {
    return reps.reduce((acc, rep) => {
      if(['BOUNCED', 'COMPLAINT'].includes(rep.emailAddressStatus)){
        acc.badEmails.push(rep);
        if(rep.selected) sections.badEmails.open = true;
      } else if (!rep.isUser) {
        acc.contacts.push(rep);
      } else if (rep.lastActive < staleDateThreshold) {
        acc.stale.push(rep);
        if(rep.selected) sections.stale.open = true;
      } else {
        acc.active.push(rep);
      }

      return acc;
    }, {
      active: [],
      stale: [],
      contacts: [],
      badEmails: []
    });
  }

  function getStaleDateThreshold() {
    const th = new Date();
    th.setFullYear(th.getFullYear() - STALE_CONTACT_YEARS);
    return th.toISOString();
  }

  function checkOpenClosed(groupedReps){
    if(groupedReps && !groupedReps.active.length && !groupedReps.contacts.length) {
      sections.stale.open = true;
      sections.badEmails.open = true;
    }

    return groupedReps;
  }

</script>

{#if !groupedRepresentatives}
  {#each representatives as contact}
    <SupplierContactComponent
      {contact}
      selected={contact.selected}
      on:select={() => select(contact)}
      on:edit={() => edit(contact)}
    />
  {/each}
{:else}
  {#each Object.values(sections) as section}
    {#if groupedRepresentatives[section.id].length}
      <div
        class="SectionHeader"
        data-icon-before="{section.open? 'expand_less': 'expand_more'}"
        on:click={() => section.open = !section.open}
      >
        <div class="SectionLabel" data-icon-after="info">
          {section.label}
          <div class="rbTooltip">
            {section.description}
          </div>
        </div>
      </div>
      {#if section.open}
        <div>
          {#each groupedRepresentatives[section.id] as contact}
            <SupplierContactComponent
              {contact}
              selected={contact.selected}
              on:select={() => select(contact)}
              on:edit={() => edit(contact)}
            />
          {/each}
        </div>
      {/if}
    {/if}
  {/each}
{/if}

<style lang="stylus">
  .SectionHeader {
    margin-top: 10px;
    color: #455a65;
    cursor: pointer;
    display: flex;

    &:before {
      margin-right: 10px;
    }

    &:hover {
      background: rgba(0, 0, 0, 0.05);
    }
  }

  .SectionLabel {
    font-size: 14px;
    font-weight: bold;
    color: #01a99d;

    &:after {
      margin-left: 4px;
      font-size: 18px;
    }
  }
</style>
